import { TranslateLoader } from "@ngx-translate/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "../environments/default";

export class CustomHttpLoader extends TranslateLoader {
  constructor(private http: HttpClient) {
    super();
  }

  getTranslation(
    lang: string,
    prefix: string = `${environment.cloud.translationsUrl}/languages?env=web&lang=` ||
      "assets/i18n/"
  ): any {
    return this.http.get(`${prefix}${lang}`, { withCredentials: false });
  }
}

export function createTranslateLoader(http: HttpClient) {
  return new CustomHttpLoader(http);
}



// WEBPACK FOOTER //
// ./src/app/utils/translate-module.ts